import Vue from 'vue'
import VueRouter from 'vue-router'
import MetaInfo from 'vue-meta'

import Layout from '../components/layout.vue'
import Index from '../components/index.vue'
import Supplier from '../components/product/supplier.vue'
import Purchase from '../components/product/purchase.vue'
import PurchaseManage from '../components/product/purchaseManage.vue'
import Law from '../components/product/law.vue'
import ContractManage from '../components/product/contractManage.vue'
import SrmCloud from '../components/product/srmcloud.vue'
import Einvoice from '../components/product/eInvoice.vue'
import Finance from '../components/product/finance.vue'
import System from '../components/product/system.vue'
import EcDeal from '../components/product/ecDeal.vue'
import Bidding from '../components/product/bidding.vue'
import Integration from '../components/product/integration.vue'
import PurchaseCoordination from '../components/product/purchaseCoordination.vue'
import CooperativePartner from '../components/aboutUs/cooperativePartner.vue'
import ServiceSupport from '../components/aboutUs/serviceSupport.vue'
import campusJob from '../components/aboutUs/campusJob.vue'
import Company from '../components/aboutUs/company.vue'
import CompanyDetail from '../components/aboutUs/companyDetail.vue'
import AboutUs from '../components/aboutUs/aboutUs.vue'
import Clientele from '../components/clientele/clientele.vue'
import ClienteleDetile from '../components/clientele/clienteleDetile.vue'
import DataDownload from '../components/dataDownload/dataDownload.vue'
import DataDownloadDetail from '../components/dataDownload/dataDownloadDetail.vue'
import Solution from '../components/solution/solution.vue'
import NotFound from '../components/common/notFound.vue'
import ServiceUnavailable from '../components/common/serviceUnavailable.vue'
import Industry from '../components/solution/industry.vue'
import Register from '../components/register/index.vue'

Vue.use(VueRouter)
Vue.use(MetaInfo)

export default function createRouter () {
  const router = new VueRouter({
    mode: 'history',
    routes: [
      {
        path: '/',
        component: Layout,
        children: [
          { path: '/', component: Index, name: 'Index', meta: { keepAlive: true, content: '首页', title: '欢迎免费体验' } }, // 首页
          { path: '/index', redirect: { name: 'Index' } },
          { path: '/supplier', component: Supplier, name: 'Supplier', meta: { content: '供应商', title: '免费体验供应商管理' } }, // 供应商
          { path: '/purchase', component: Purchase, name: 'Purchase', meta: { content: '采购', title: '免费体验采购员工作台' } }, // 采购
          {
            path: '/purchasemanage',
            component: PurchaseManage,
            name: 'PurchaseManage',
            meta: { content: '寻源', title: '免费体验电子化采购寻源' }
          }, // 寻源
          { path: '/law', component: Law, name: 'Law', meta: { content: '法务', title: '免费体验法务工作台' } }, // 法务
          {
            path: '/contractmanage',
            component: ContractManage,
            name: 'ContractManage',
            meta: { content: '合同管理', title: '免费体验合同管理' }
          }, // 合同管理
          { path: '/einvoice', component: Einvoice, name: 'Einvoice', meta: { content: '电子发票' } }, // 电子发票
          { path: '/finance', component: Finance, name: 'Finance', meta: { content: '财务', title: '免费体验财务工作台' } }, // 财务
          { path: '/system', component: System, name: 'System', meta: { content: '内部系统集成', title: '获取系统集成方案' } }, // 内部系统集成
          {
            path: '/srmcloud',
            component: SrmCloud,
            name: 'SrmCloud',
            meta: { content: 'SRM云', title: '免费体验甄采云' }
          }, // SRM云
          { path: '/ecdeal', component: EcDeal, name: 'EcDeal', meta: { content: '电商及撮合交易', title: '免费体验采购商城' } }, // 电商及撮合交易
          {
            path: '/integration',
            component: Integration,
            name: 'Integration',
            meta: { content: '第三方平台集成', title: '体验开放平台增值服务' }
          }, // 第三方平台集成
          {
            path: '/servicesupport',
            component: ServiceSupport,
            name: 'ServiceSupport',
            meta: { content: '服务支持', title: '获取服务支持' }
          }, // 服务支持
          {
            path: '/campusjob',
            component: campusJob,
            name: 'campusJob',
            meta: { content: '校园招聘', title: '欢迎免费体验' }
          },
          { path: '/company', component: Company, name: 'Company', meta: { content: '公司动态', title: '欢迎免费体验' } }, // 公司动态
          { path: '/company/detail', component: CompanyDetail, name: 'CompanyDetail', meta: { content: '动态详情' } },
          {
            path: '/purchasecoordination',
            component: PurchaseCoordination,
            name: 'PurchaseCoordination',
            meta: { content: '采购协同', title: '免费体验采购协同' }
          }, // 采购协同
          {
            path: '/cooperativepartner',
            component: CooperativePartner,
            name: 'CooperativePartner',
            meta: { content: '合作伙伴', title: '加入合作伙伴计划' }
          }, // 关于我们（合作伙伴）
          { path: '/aboutus', component: AboutUs, name: 'AboutUs', meta: { content: '大事记', title: '免费体验甄云产品' } }, // 关于我们（公司介绍，联系我们，大事记）
          { path: '/clientele', component: Clientele, name: 'Clientele', meta: { content: '客户案例', title: '获取客户案例详情' } }, // 客户案例
          {
            path: '/clienteledetile',
            component: ClienteleDetile,
            name: 'ClienteleDetile',
            meta: { content: '客户案例详情页', title: '获取客户方案详情' }
          }, // 客户案例详情页 (无banner)
          { path: '/datadownload', component: DataDownload, name: 'DataDownload', meta: { content: '资料下载' } }, // 资料下载
          {
            path: '/datadownload/detail',
            component: DataDownloadDetail,
            name: 'DataDownloadDetail',
            meta: { content: '资料详情页' }
          }, // 资料详情页
          { path: '/solution/:code', component: Solution, name: 'Solution', meta: { content: '解决方案详情页' } }, // 解决方案详情页
          { path: '/serviceunavailable', component: ServiceUnavailable, name: 'ServiceUnavailable' }, // 503
          { path: '/industry', component: Industry, name: 'Industry', meta: { content: '解决总方案' } },
          { path: '/bidding', component: Bidding, name: 'Bidding', meta: { content: '招标', title: '免费体验招投标管理' } }, // 招标
          { path: '/register', component: Register, name: 'Register', meta: { content: '注册' } }, // 注册
          { path: '/404', component: NotFound, name: 'NotFound' },
          { path: '*', redirect: { name: 'NotFound' } } // 404// 解决总方案
        ]
      }
    ],
    scrollBehavior (to, from, savedPosition) {
      return { x: 0, y: 0 }
    }
  })
  return router
}



// WEBPACK FOOTER //
// ./src/router/index.js